import React from "react";

// Badge — pastilla de color compartida por toda la app (tabla de Personal,
// Pisos y Clientes en Administración, estados de préstamo en Gestionar,
// estados de línea/ruta en Rutas...). Tonos disponibles: green/red/blue/
// gray/amber/purple (definidos en App.css como .badge-<tono>).
export default function Badge({ tone = "gray", children }) {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}
